/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonLightResponse
 */
export interface PersonLightResponse {
    /**
     * the unique identifier of the person
     * @type {string}
     * @memberof PersonLightResponse
     */
    id?: string;
    /**
     * the firstname of the person
     * @type {string}
     * @memberof PersonLightResponse
     */
    firstname?: string;
    /**
     * the lastname of the person
     * @type {string}
     * @memberof PersonLightResponse
     */
    lastname?: string;
    /**
     * the role of the person
     * @type {string}
     * @memberof PersonLightResponse
     */
    role?: string;
}

/**
 * Check if a given object implements the PersonLightResponse interface.
 */
export function instanceOfPersonLightResponse(value: object): value is PersonLightResponse {
    return true;
}

export function PersonLightResponseFromJSON(json: any): PersonLightResponse {
    return PersonLightResponseFromJSONTyped(json, false);
}

export function PersonLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function PersonLightResponseToJSON(json: any): PersonLightResponse {
    return PersonLightResponseToJSONTyped(json, false);
}

export function PersonLightResponseToJSONTyped(value?: PersonLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'role': value['role'],
    };
}

